import React from "react";
import { Spinner } from "react-bootstrap";

const Loading = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-3 rounded-xl bg-content1 p-6 shadow-lg">
        <Spinner size="lg" />
        <span className="text-sm text-default-600">Cargando...</span>
      </div>
    </div>
  );
};

export default Loading;
